import createHasSubmitSucceeded from './selectors/hasSubmitSucceeded';
import plain from './structure/plain';

export default createHasSubmitSucceeded(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/hasSubmitSucceeded.js
// module id = 625
// module chunks = 0